import { Navigate, useLocation } from 'react-router-dom'
// import { LoadingFallback } from './ui/loading-fallback'
import { useIsLoggedIn } from '@ekonavi/auth';

interface ProtectedRouteProps {
  children: React.ReactNode
}

// DEV_SKIP_AUTH flag - set to true to bypass authentication during development
const DEV_SKIP_AUTH = import.meta.env.VITE_DEV_SKIP_AUTH === 'true' || false;

export function ProtectedRoute({ children }: ProtectedRouteProps) {
	const location = useLocation();

	const isLoggedIn = useIsLoggedIn();
	// if (loading) {
	//   return <LoadingFallback className="h-screen" />
	// }

	// Skip auth check if DEV_SKIP_AUTH is enabled
	if (DEV_SKIP_AUTH) {
		console.warn('⚠️ DEV_SKIP_AUTH is enabled - authentication is bypassed');
		return <>{children}</>;
	}

	if (!isLoggedIn) {
		// Redirect to login page with return url
		return (
			<Navigate
				to='/auth'
				state={{ from: location }}
				replace
			/>
		);
	}

	return <>{children}</>;
}